import { render, staticRenderFns } from "./onaydialog.vue?vue&type=template&id=7dfaba9a&"
import script from "./onaydialog.vue?vue&type=script&lang=js&"
export * from "./onaydialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports